export const copyLinkSuccess = {
  title: '已复制链接',
};
